import React from 'react';
import { connect } from 'react-redux';
import { Toast } from '@adc/parallax-component-library';
import { useRouter } from 'Hooks';
import { GeneralModal } from 'Components/utility';
const mapState = ({ nav: { location, initErrorStatus, queryString, data } }) => {
    return {
        initErrorStatus,
        queryString,
        location,
        data,
    };
};
const connector = connect(mapState);
const App = ({ initErrorStatus, queryString, location, data }) => {
    const { Component, props } = useRouter(location, queryString, initErrorStatus, data);
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, { ...props }),
        React.createElement(Toast, { parentHeight: window.innerHeight, bottomMargin: 30, testID: "Toast.global" }),
        React.createElement(GeneralModal, null)));
};
export default connector(App);
